import { NavLink, Route, Switch, useParams } from "polyrouter";
import React from "react";
import { useTranslation } from "utilities/i18n";
import { Layout } from "views/Main/Layouts";
import { UserGroupDetailsContainer } from "./UserGroupDetailsContainer";

export const DeviceUserGroupDetailsRouter: React.FC = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();

  const { Sidebar } = Layout;
  return (
    <>
      <Sidebar>
        <ul className="menu router">
          <li>
            <NavLink nest exact to="">
              {t("OVERVIEW")}
            </NavLink>
          </li>
        </ul>
      </Sidebar>
      <Switch>
        <Route nest path="">
          {id && <UserGroupDetailsContainer groupId={id} />}
        </Route>
      </Switch>
    </>
  );
};
